import { usdtAbi } from "./abi";
import store from "@/store";
import Web3 from "web3";
import { USDT_ADDRESS } from "./constants";
import { resetFundingWriteContract } from "./funding/index.js";

export { USDT_ADDRESS };

export let gasPrice = "3000000000";
let web3Provider;
export let WEB3;
export let web3js;
let { ethereum } = window;

/** 从 store 读取当前连接的钱包地址 */
export function getAccountAddress() {
  return store.state.user.accountAddress;
}

/** BSC 主网 chainId */
const networkVersion = "56";
export let isChainId = true;

/** BSC 公开 RPC：只读查询统一走稳定节点 */
export const PUBLIC_RPC_URL = "https://bsc.publicnode.com";

const readOnlyWeb3 = new Web3(new Web3.providers.HttpProvider(PUBLIC_RPC_URL));

/** 当前读请求是否走公开 RPC（未连接钱包时） */
export function isUsingPublicRpc() {
  return !web3js;
}

export function shouldNotifyRpcError(err) {
  if (isUsingPublicRpc()) {
    return false;
  }
  const msg = String(
    err?.message || err?.reason || err?.data?.message || err || ""
  ).toLowerCase();
  const connectionHints = [
    "failed to fetch",
    "networkerror",
    "network error",
    "connection error",
    "couldn't connect",
    "could not connect",
    "connect to node",
    "invalid json rpc",
    "timeout",
    "etimedout",
    "econnrefused",
    "enotfound",
    "load failed",
    "cors",
  ];
  if (connectionHints.some((hint) => msg.includes(hint))) {
    return false;
  }
  return true;
}

if (ethereum) {
  web3Provider = ethereum;
} else if (window.web3) {
  web3Provider = Web3.currentProvider;
} else {
  web3Provider = new Web3.providers.HttpProvider(PUBLIC_RPC_URL);
}
WEB3 = new Web3(web3Provider);

let tokenContractInstance;
let readUsdtContract;

function createReadContracts(web3) {
  readUsdtContract = new web3.eth.Contract(usdtAbi, USDT_ADDRESS);
}

createReadContracts(readOnlyWeb3);

/** 链上只读始终走公开 RPC，避免钱包节点 eth_call 不稳定导致数据为空 */
export function getReadWeb3() {
  return readOnlyWeb3;
}

export function getWriteWeb3() {
  return web3js || null;
}

export function getUsdtContract() {
  return tokenContractInstance || readUsdtContract;
}

export async function checkNetwork(web3Instance) {
  try {
    const res = await web3Instance.eth.net.getId();
    if (String(res) !== networkVersion) {
      isChainId = false;
      console.error("error network");
    } else {
      isChainId = true;
    }
    return isChainId;
  } catch (err) {
    return false;
  }
}

export function requireBscNetwork() {
  if (!isChainId) {
    throw new Error("Wrong network");
  }
}

/** 连接钱包后初始化 USDT 合约实例 */
export const contractInstanceInit = function (provider, account) {
  web3js = provider;
  resetFundingWriteContract();
  store.commit("SET_ADDRESS", account);
  checkNetwork(web3js);
  web3js.eth.getGasPrice().then((res) => {
    gasPrice = res;
  });
  const fromAddress = getAccountAddress();
  return new Promise((resolve) => {
    tokenContractInstance = new web3js.eth.Contract(usdtAbi, USDT_ADDRESS, {
      from: fromAddress,
      gasPrice: "0",
    });
    createReadContracts(web3js);
    resolve();
  });
};
